import { OperationVariables, QueryHookOptions, useQuery } from '@apollo/client';
import { DocumentNode } from 'graphql';
import { useActiveTabContext } from '../../activeTabContext/useActiveTabContext';

export function useCustomQuery<TData = any, TVariables = OperationVariables>(
  query: DocumentNode,
  options: QueryHookOptions<TData, TVariables>,
  traceSampleRate?: number
) {
  // Stop polling if window isn't focused
  // Stop polling if a pollinterval isn't provided (e.g. when switching on/off)
  // Stop polling if there's a team mismatch
  const activeTabContext = useActiveTabContext();
  const polling = !!options.pollInterval && !!activeTabContext.isWindowFocused;

  return useQuery<TData, TVariables>(query, {
    fetchPolicy: 'cache-and-network',
    ...options,
    context: {
      polling: polling,
      traceSampleRate,
      ...options.context,
    },
  });
}
